import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/cuenta/profile';
import { actions as actionLogin} from '../../../../redux/modules/cuenta/login';
import Profile from './Profile';


const ms2p = (state) => {
    return {
        ...state.login,
    };
};

const md2p = { ...actions, getMe: actionLogin.getMe };

export default connect(ms2p, md2p)(Profile);
